function showCartLoader() {
  document.getElementById('cartDrawerLoader').classList.add('active');
}
function hideCartLoader() {
  document.getElementById('cartDrawerLoader').classList.remove('active');
}

document.addEventListener('click', function (e) {
  var customRemoveBtn = e.target.closest('.custom_remove');
  if (!customRemoveBtn) return;

  e.preventDefault();

  var cartItem = customRemoveBtn.closest('.cart-items__price');
  console.log('cartItem', cartItem);
  
  var defaultRemoveBtn = cartItem?.querySelector('.default_remove_button');

  if (defaultRemoveBtn) {
    defaultRemoveBtn.click(); // 🚀 triggers native ajax remove
  }
});
document.addEventListener("change", function (e) {
  const toggle = e.target.closest(".shipping-protection-toggle");
  if (!toggle) return;
  if (toggle.checked) {
    const buttonShipping = document.querySelector(".shipping-protection-btn");
    if (buttonShipping) {
      buttonShipping.click();
    }
  }else if(document.querySelector('.cart-items__remove.remove--shipping-protection')!=null){
    const removeShipping = document.querySelector('.cart-items__remove.remove--shipping-protection')
    if (removeShipping) {
      removeShipping.click();
    }
  }
});

document.addEventListener('click', function (e) {
  var checkoutButtonObj = e.target.closest('.cart__checkout-button');
  if (!checkoutButtonObj) return;
  var cartItem = document.querySelector('.checkout-text-custom');
  if(cartItem){
    cartItem.style.display="none";
  }
  var loaderDiv = document.querySelector('.checkout-loader-custom');
  if (loaderDiv) {
    loaderDiv.classList.remove('hidden');
  }
});

// FREE PRORUCT REMOVE FOR THAT START
document.addEventListener('click', function (e) {
  var removeButtonObj = e.target.closest('.remove_main_product');
  if (!removeButtonObj) return;
  showCartLoader();
});
if (document.querySelector('.product-information [name="properties[_free_gift]"]')) {
  const getFreeProducts = document.querySelector('.product-information [name="properties[_free_gift]"]').value;

  if (getFreeProducts) {
    
    const freeVariantIds = getFreeProducts
      .split(/[\n,]+/)
      .map(v => v.trim())
      .filter(Boolean)
      .map(Number);

    let running = false;
    let internalCartUpdate = false;

    async function refreshCartDrawer() {
      const cartEl = document.querySelector('cart-items-component');
      if (cartEl && typeof cartEl.onLineItemRemove === 'function') {
        showCartLoader();
        await cartEl.onLineItemRemove(getFreeProducts.length);
      }
    }

    async function handleFreeProductCheck() {

      if (running) return;
      running = true;

      try {
        let cart = await fetch('/cart.js').then(r => r.json());

        let paidProducts = 0;
        cart.items.forEach(item => {
          if (!freeVariantIds.includes(item.variant_id)) {
            paidProducts += item.quantity;
          }
        });

        const updates = {};
        cart.items.forEach(item => {
          if (freeVariantIds.includes(item.variant_id)) {
            if (paidProducts === 0) {
              updates[item.variant_id] = 0;
            } else if (item.quantity > 1) {
              updates[item.variant_id] = 1;
            }
          }
        });

        cart.items.forEach(function (item) {
          if (item.variant_id === 53615574778131) updates[item.variant_id] = 0;
        });
        const changed = Object.keys(updates).length > 0;

        if (changed) {
          showCartLoader();
          internalCartUpdate = true;
          cart = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          }).then(r => r.json());
          internalCartUpdate = false;
        }

        const freeExists = cart.items.some(item =>
          freeVariantIds.includes(item.variant_id)
        );

        document.querySelectorAll('.free-product-custom').forEach(input => {
          const qty = input.parentElement.querySelector('.hidden-input-custom');
          if (freeExists) {
            input.disabled = true;
            if (qty) qty.disabled = true;
          } else {
            input.disabled = false;
            if (qty) qty.disabled = false;
          }
        });

        if (changed) {
          await refreshCartDrawer();
          hideCartLoader();
        }
      } catch (err) {
        console.error('handleFreeProductCheck failed', err);
        hideCartLoader();
      } finally {
        internalCartUpdate = false;
        running = false;
      }
    }

    const originalFetch = window.fetch;

    window.fetch = function () {

      return originalFetch.apply(this, arguments).then(res => {

        const url = arguments[0];

        if (
          !internalCartUpdate &&
          typeof url === "string" &&
          (
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update')
          )
        ) {
          handleFreeProductCheck();
        }

        return res;

      });

    };

    document.addEventListener('DOMContentLoaded', handleFreeProductCheck);

  }
}
// FREE PRORUCT REMOVE FOR THAT END


// H5 (re-enabled): rewrite the Judge.me PDP preview-badge text.
(function () {
  function rewriteAll() {
    document.querySelectorAll('.jdgm-prev-badge .jdgm-prev-badge__text').forEach(function (el) {
      var badge = el.closest('.jdgm-prev-badge');
      var count = (badge && badge.getAttribute('data-number-of-reviews')) || '127';
      var inCart = !!el.closest('cart-drawer-component, .cart-drawer, .cart-drawer__dialog, cart-items-component, .cart-page, .cart-items');
      var target = inCart ? '4.8/5 (' + count + ' reviews)' : 'Rated "Excellent" 4.8/5 (' + count + ' reviews)';
      if (el.textContent !== target) el.textContent = target;
    });
  }
  rewriteAll();
  var mo = new MutationObserver(rewriteAll);
  mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  setTimeout(function () { mo.disconnect(); rewriteAll(); }, 15000);
})();

// Make each payment-icon SVG's internal ids (gradients/clipPaths) unique so duplicate
// instances (PDP row + cart row) don't collide — fixes the Discover orange not painting.
(function () {
  function uniquify() {
    document.querySelectorAll('.payment-icons__list svg, .cart_payment_icons svg').forEach(function (svg) {
      if (svg.__piUniq) return;
      svg.__piUniq = true;
      uniquify._n = (uniquify._n || 0) + 1;
      var suffix = '__pi' + uniquify._n;
      svg.querySelectorAll('[id]').forEach(function (el) {
        var oldId = el.getAttribute('id');
        var newId = oldId + suffix;
        el.setAttribute('id', newId);
        svg.querySelectorAll('*').forEach(function (node) {
          ['fill', 'stroke', 'clip-path', 'mask', 'filter'].forEach(function (a) {
            var v = node.getAttribute(a);
            if (v && v.indexOf('url(#' + oldId + ')') !== -1) {
              node.setAttribute(a, v.replace('url(#' + oldId + ')', 'url(#' + newId + ')'));
            }
          });
          ['href', 'xlink:href'].forEach(function (a) {
            if (node.getAttribute(a) === '#' + oldId) node.setAttribute(a, '#' + newId);
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', uniquify);
  else uniquify();
  new MutationObserver(uniquify).observe(document.body, { childList: true, subtree: true });
})();
